import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import {
  getCategoriesNavigation,
  type Category,
} from "@/services/api/categories";

const categoriesNavigationKeys = {
  all: ["categories", "navigation"] as const,
  list: () => [...categoriesNavigationKeys.all] as const,
};

export function useCategoriesNavigation(
  options?: Omit<UseQueryOptions<Category[], Error>, "queryKey" | "queryFn">
) {
  return useQuery<Category[], Error>({
    queryKey: categoriesNavigationKeys.list(),
    queryFn: getCategoriesNavigation,
    staleTime: 5 * 60 * 1000,
    ...options,
  });
}
